import { Editor } from '@tinymce/tinymce-react'
import { BaseSyntheticEvent, FC, MouseEvent, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import uuid from 'react-uuid'
import Swal from 'sweetalert2'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Button } from '../../../components/Button/Button'
import { Input } from '../../../components/Input/Input'
import { Loading } from '../../../components/Loading/Loading'
import { DELETE, GET, POST, PUT } from '../../../services/api'
import { i18n } from '../../../translate/i18n'
import useAuth from '../../../hooks/useAuth'
import { ModalWrapper } from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../../hooks/useModals'
import { ModalDelete } from '../../../components/Modals/General/ModalDelete/ModalDelete'
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import styles from './update.module.css'
import usePluginSpace from '../../../hooks/usePluginSpace'
import { set } from 'rsuite/esm/internals/utils/date'
import { EditorQuill } from '../../../components/EditorQuill/EditorQuill'

type AppconfigResponseType = {
  name: string
  locationId: number
  info: string
  type: string
  background: null | string
  banner: null | string
  img: null | string
  icon: null | string
  content: {
    noConfirmed?: boolean
    noShadow?: boolean
    qtdProductsPagination: number
    useLogoMenu: boolean
    colorLogo?: string
    useLogoTotvs?: boolean
    pdv: any
    orderCategory: string
    flagDiscount: string
    noUseViewMode?: boolean

    /*Novos Campos */
    showFlagDiscount?: boolean

    /* Usados No Atacado */
    showButtonClassification?: boolean
    showButtonCatalog?: boolean
    showClassificationName?: boolean
    showCatalogName?: boolean
    showProductInventory?: boolean
    showProductMark?: boolean
    showProductSku?: boolean

    /* */
    webappcolor: {
      backgroundbuttonhome: string
      backgroundcart: string
      backgroundfooter: string
      backgroundheader: string
      backgroundmenu: string
      backgroundstatus: string
      backgroundstatusactive: string
      backgroundtitlebar: string
      backgroundwebapp: string
      fontbutton: string
      fontbuttonhome: string
      fontcart: string
      fontcategory: string
      fontheader: string
      fontinfocart: string
      fontmenu: string
      fontstatus: string
      fonttitlebar: string
      highlightfooter: string
      iconsfooter: string
      iconsheader: string
      icontitlebar: string
      webappbutton: string
      flagDiscountColor: string
    }
    useCategoryList?: boolean
  }
}

type AppconfigResponseSendType = {
  name?: string
  locationId?: number
  info?: string
  background?: null | string
  banner?: null | string
  img?: null | string
  icon?: null | string
  content?: {
    noConfirmed?: boolean
    noShadow?: boolean
    qtdProductsPagination?: number
    useLogoMenu?: boolean
    colorLogo?: string
    useLogoTotvs?: boolean
    pdv?: any
    orderCategory?: string
    flagDiscount?: string
    noUseViewMode?: boolean

    /*Novos Campos */
    showFlagDiscount?: boolean

    /* Usados No Atacado */
    showButtonClassification?: boolean
    showButtonCatalog?: boolean
    showClassificationName?: boolean
    showCatalogName?: boolean
    showProductInventory?: boolean
    showProductMark?: boolean
    showProductSku?: boolean

    webappcolor?: {
      backgroundbuttonhome?: string
      backgroundcart?: string
      backgroundfooter?: string
      backgroundheader?: string
      backgroundmenu?: string
      backgroundstatus?: string
      backgroundstatusactive?: string
      backgroundtitlebar?: string
      backgroundwebapp?: string
      fontbutton?: string
      fontbuttonhome?: string
      fontcart?: string
      fontcategory?: string
      fontheader?: string
      fontinfocart?: string
      fontmenu?: string
      fontstatus?: string
      fonttitlebar?: string
      highlightfooter?: string
      iconsfooter?: string
      iconsheader?: string
      icontitlebar?: string
      webappbutton?: string
      flagDiscountColor?: string
    }
    useCategoryList?: boolean
  }
}

type LocationResponseType = {
  id: number
  name: string
  type: string
}

type SlidersImage = {
  image: File
  order: number
}

type ImageSliderAggregator = {
  id: number
  pluginspaceId: number
  aggregatorId: number
  path: string
  imgSuffix: string
  order: number
  typeImg: string
  created: string
  updated: string
  deleted?: any
}

const EditarWebappContent: FC = () => {
  const navigate = useNavigate()
  const { showWrapperModal, closeWrapperModal, showDeleteModal } = useModals()
  const { id } = useParams()
  const { loginInfo } = useAuth()
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState('')
  const [locationId, setLocationId] = useState<null | number>(null)
  const [info, setInfo] = useState('')
  const [background, setBackground] = useState<File | null | string>()
  const [banner, setBanner] = useState<File | null | string>()
  const [img, setImg] = useState<File | null | string>()
  const [icon, setIcon] = useState<File | null | string>()
  const [firstStateBackground, setFirstStateBackground] = useState<null | string>()
  const [firstStateBanner, setFirstStateBanner] = useState<null | string>()
  const [firstStateImg, setFirstStateImg] = useState<null | string>()
  const [firstStateIcon, setFirstStateIcon] = useState<null | string>()

  const [qtdProductsPagination, setQtdProductsPagination] = useState(10)
  const [selectProductsPagination, setSelectProductsPagination] = useState([
    { select: '5', value: '5' },
    { select: '10', value: '10' },
    { select: '25', value: '25' },
    { select: '50', value: '50' },

  ])

  const [useLogoMenu, setUseLogoMenu] = useState(false)
  const [colorLogo, setColorLogo] = useState('black')
  const [useLogoTotvs, setUseLogoTotvs] = useState(false)
  const [backgroundbuttonhome, setBackgroundbuttonhome] = useState<string>('')
  const [backgroundcart, setBackgroundcart] = useState<string>('')
  const [backgroundfooter, setBackgroundfooter] = useState<string>('')
  const [backgroundheader, setBackgroundheader] = useState<string>('')
  const [backgroundmenu, setBackgroundmenu] = useState<string>('')
  const [backgroundstatus, setBackgroundstatus] = useState<string>('')
  const [backgroundstatusactive, setBackgroundstatusactive] = useState<string>('')
  const [backgroundtitlebar, setBackgroundtitlebar] = useState<string>('')
  const [backgroundwebapp, setBackgroundwebapp] = useState<string>('')
  const [fontbutton, setFontbutton] = useState<string>('')
  const [fontbuttonhome, setFontbuttonhome] = useState<string>('')
  const [fontcart, setFontcart] = useState<string>('')
  const [fontcategory, setFontcategory] = useState<string>('')
  const [fontheader, setFontheader] = useState<string>('')
  const [fontinfocart, setFontinfocart] = useState<string>('')
  const [fontmenu, setFontmenu] = useState<string>('')
  const [fontstatus, setFontstatus] = useState<string>('')
  const [fonttitlebar, setFonttitlebar] = useState<string>('')
  const [highlightfooter, setHighlightfooter] = useState<string>('')
  const [iconsfooter, setIconsfooter] = useState<string>('')
  const [iconsheader, setIconsheader] = useState<string>('')
  const [icontitlebar, setIcontitlebar] = useState<string>('')
  const [webappbutton, setWebappbutton] = useState<string>('')
  const [pdv, setPdv] = useState<any>()
  const [useCategoryList, setUseCategoryList] = useState(false)
  const [noUseViewMode, setNoUseViewMode] = useState(false)
  const [noShadow, setNoShadow] = useState(false)
  const [noConfirmed, setConfirmed] = useState(false)
  const [loadingImages, setLoadingImages] = useState(false)
  const [orderCategory, setOrderCategory] = useState('category')
  const [flagDiscount, setFlagDiscount] = useState('trigonal')
  const [showFlagDiscount, setShowFlagDiscount] = useState(true)
  const [flagDiscountColor, setFlagDiscountColor] = useState<string>('')

  const [canAlert, setCanAlert] = useState(false)

  /* Usado somente para atacado */
  const { getPluginSpace } = usePluginSpace()
  const [isWholesale, setIsWholesale] = useState(false)
  const [showButtonClassification, setShowButtonClassification] = useState(false)
  const [showButtonCatalog, setShowButtonCatalog] = useState(false)
  const [showCatalogName, setShowCatalogName] = useState(false)
  const [showClassificationName, setShowClassificationName] = useState(false)
  const [showProductInventory, setShowProductInventory] = useState(false)
  const [showProductMark, setShowProductMark] = useState(false)
  const [showProductSku, setShowProductSku] = useState(false)


  /* Campos utilizados para o slider do agregador */

  const [slidesImageAggregator, setSlidesImageAggregator] = useState<any>()
  const [slidesImageAggregatorOrder, setSlidesImageAggregatorOrder] = useState<number>(0)

  const [slidesImageAggregatorPreviewHomePage, setSlidesImageAggregatorPreviewHomePage] = useState<
    SlidersImage[]
  >([])
  const [slidesImageAggregatorPreviewInitial, setSlidesImageAggregatorPreviewInitial] = useState<
    SlidersImage[]
  >([])

  const [ImageSlidesAggregatorInitial, setImageSlidesAggregatorInitial] = useState<
    ImageSliderAggregator[]
  >([])
  const [ImageSlidesAggregatorHomePage, setImageSlidesAggregatorHomePage] = useState<
    ImageSliderAggregator[]
  >([])

  const [action, setAction] = useState<'initial' | 'homepage'>('initial')

  const [idImageSlider, setIdImageSlider] = useState<number>(0)

  const getAppconfig = async () => {
    try {
      setLoading(true)

      const thisPluginsSpace = await getPluginSpace()

      const isWholeSaler = thisPluginsSpace && thisPluginsSpace.wholeSaler


      const appRes = await GET(`/appconfig/${id}`)
      const appconfig: AppconfigResponseType = appRes.data[0]



      setIsWholesale(isWholeSaler && appconfig.type === 'qr_whole_sale')
      setName(appconfig.name)
      setLocationId(appconfig.locationId)
      setInfo(appconfig.info)

      setBackground(
        appconfig.background && appconfig.background.substring(0, 4) === 'http'
          ? appconfig.background
          : appconfig.background
            ? process.env.REACT_APP_AWS_S3_URL + appconfig.background
            : null
      )

      setBanner(
        appconfig.banner?.includes('default/no-image.png')
          ? null
          : appconfig.banner && appconfig.banner.substring(0, 4) === 'http'
            ? appconfig.banner
            : appconfig.banner
              ? process.env.REACT_APP_AWS_S3_URL + appconfig.banner
              : null
      )
      setImg(
        appconfig.img && appconfig.img.substring(0, 4) === 'http'
          ? appconfig.img
          : appconfig.img
            ? process.env.REACT_APP_AWS_S3_URL + appconfig.img
            : null
      )
      setIcon(
        appconfig.icon && appconfig.icon.substring(0, 4) === 'http'
          ? appconfig.icon
          : appconfig.icon
            ? process.env.REACT_APP_AWS_S3_URL + appconfig.icon
            : null
      )
      setFirstStateBackground(
        appconfig.background && appconfig.background.substring(0, 4) === 'http'
          ? appconfig.background
          : appconfig.background
            ? process.env.REACT_APP_AWS_S3_URL + appconfig.background
            : null
      )
      setFirstStateBanner(
        appconfig.banner && appconfig.banner.substring(0, 4) === 'http'
          ? appconfig.banner
          : appconfig.banner
            ? process.env.REACT_APP_AWS_S3_URL + appconfig.banner
            : null
      )
      setFirstStateImg(
        appconfig.img && appconfig.img.substring(0, 4) === 'http'
          ? appconfig.img
          : appconfig.img
            ? process.env.REACT_APP_AWS_S3_URL + appconfig.img
            : null
      )
      setFirstStateIcon(
        appconfig.icon && appconfig.icon.substring(0, 4) === 'http'
          ? appconfig.icon
          : appconfig.icon
            ? process.env.REACT_APP_AWS_S3_URL + appconfig.icon
            : null
      )

      setPdv(appconfig.content.pdv)


      const find = selectProductsPagination.find((el) => el.value === appconfig.content.qtdProductsPagination.toString())
      setQtdProductsPagination(find ? parseInt(find.value) : 10)
      setUseLogoMenu(appconfig.content.useLogoMenu)
      setConfirmed(appconfig.content.noConfirmed ? appconfig.content.noConfirmed : false)
      setNoShadow(appconfig.content.noShadow ? appconfig.content.noShadow : false)
      setColorLogo(appconfig.content.colorLogo ? appconfig.content.colorLogo : 'black')
      setUseLogoTotvs(false)
      setBackgroundbuttonhome(appconfig.content.webappcolor.backgroundbuttonhome)
      setBackgroundcart(appconfig.content.webappcolor.backgroundcart)
      setBackgroundfooter(appconfig.content.webappcolor.backgroundfooter)
      setBackgroundheader(appconfig.content.webappcolor.backgroundheader)
      setBackgroundmenu(appconfig.content.webappcolor.backgroundmenu)
      setBackgroundstatus(appconfig.content.webappcolor.backgroundstatus)
      setBackgroundstatusactive(appconfig.content.webappcolor.backgroundstatusactive)
      setBackgroundtitlebar(appconfig.content.webappcolor.backgroundtitlebar)
      setBackgroundwebapp(appconfig.content.webappcolor.backgroundwebapp)
      setFontbutton(appconfig.content.webappcolor.fontbutton)
      setFontbuttonhome(appconfig.content.webappcolor.fontbuttonhome)
      setFontcart(appconfig.content.webappcolor.fontcart)
      setFontcategory(appconfig.content.webappcolor.fontcategory)
      setFontheader(appconfig.content.webappcolor.fontheader)
      setFontinfocart(appconfig.content.webappcolor.fontinfocart)
      setFontmenu(appconfig.content.webappcolor.fontmenu)
      setFontstatus(appconfig.content.webappcolor.fontstatus)
      setFonttitlebar(appconfig.content.webappcolor.fonttitlebar)
      setHighlightfooter(appconfig.content.webappcolor.highlightfooter)
      setIconsfooter(appconfig.content.webappcolor.iconsfooter)
      setIconsheader(appconfig.content.webappcolor.iconsheader)
      setIcontitlebar(appconfig.content.webappcolor.icontitlebar)
      setWebappbutton(appconfig.content.webappcolor.webappbutton)
      setFlagDiscountColor(appconfig.content.webappcolor.flagDiscountColor)
      setUseCategoryList(
        appconfig.content.useCategoryList ? appconfig.content.useCategoryList : false
      )
      setNoUseViewMode(appconfig.content.noUseViewMode ? appconfig.content.noUseViewMode : false)
      setOrderCategory(
        appconfig.content.orderCategory ? appconfig.content.orderCategory : 'category'
      )
      setFlagDiscount(appconfig.content.flagDiscount ? appconfig.content.flagDiscount : 'round')

      setShowFlagDiscount(appconfig.content.showFlagDiscount ? appconfig.content.showFlagDiscount : false)


      /** Usado para somente o atacado */
      setShowButtonClassification(appconfig.content.showButtonClassification ? appconfig.content.showButtonClassification : false)
      setShowButtonCatalog(appconfig.content.showButtonCatalog ? appconfig.content.showButtonCatalog : false)
      setShowCatalogName(appconfig.content.showCatalogName ? appconfig.content.showCatalogName : false)
      setShowClassificationName(appconfig.content.showClassificationName ? appconfig.content.showClassificationName : false)
      setShowProductInventory(appconfig.content.showProductInventory ? appconfig.content.showProductInventory : false)
      setShowProductSku(appconfig.content.showProductSku ? appconfig.content.showProductSku : false)
      setShowProductMark(appconfig.content.showProductMark ? appconfig.content.showProductMark : false)



      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const deleteImage = async (image: string) => {
    try {
      await POST('/upload-images/delete-one', {
        url: image,
      })
    } catch (e) {
      return null
    }
  }

  const saveAppconfig = async () => {
    try {
      if (!name || !locationId) {
        setCanAlert(true)
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      } else {
        setLoading(true)

        let appconfigData: AppconfigResponseSendType = {
          name,
          info,
          locationId,
        }
        if (img && img !== firstStateImg) {
          if (firstStateImg) deleteImage(firstStateImg)
          const formData = new FormData()
          formData.append('file', img)
          formData.append('nameImage', `${isWholesale ? `whole-sale-appconfig-logo-${uuid()}.jpg` : `appconfig-logo-${uuid()}.jpg`}`)
          formData.append('originalSize', 'true')
          const imageRes = await POST('/upload-images/upload-one', formData)
          appconfigData.img = imageRes.success ? imageRes.image : ''
        }
        if (!img || img === '') {
          appconfigData.img = img
        }

        if (icon && icon !== firstStateIcon) {
          if (firstStateIcon) deleteImage(firstStateIcon)
          const formData = new FormData()
          formData.append('file', icon)
          formData.append('nameImage', isWholesale ? `whole-sale-appconfig-icon-${uuid()}.jpg` : `appconfig-icon-${uuid()}.jpg`)
          formData.append('originalSize', 'true')
          const imageRes = await POST('/upload-images/upload-one', formData)
          appconfigData.icon = imageRes.success ? imageRes.image : ''
        }
        if (!icon || icon === '') {
          appconfigData.icon = icon
        }

        if (banner && banner !== firstStateBanner) {
          if (firstStateBanner) deleteImage(firstStateBanner)
          const formData = new FormData()
          formData.append('file', banner)
          formData.append('nameImage', isWholesale ? `whole-sale-appconfig-banner-${uuid()}.jpg` : `appconfig-banner-${uuid()}.jpg`)
          formData.append('originalSize', 'true')
          const imageRes = await POST('/upload-images/upload-one', formData)
          appconfigData.banner = imageRes.success ? imageRes.image : ''
        }
        if (!banner || banner === '') {
          appconfigData.banner = banner
        }

        if (background && background !== firstStateBackground) {
          if (firstStateBackground) deleteImage(firstStateBackground)
          const formData = new FormData()
          formData.append('file', background)
          formData.append('nameImage', isWholesale ? `whole-sale-appconfig-background-${uuid()}.jpg` : `appconfig-background-${uuid()}.jpg`)
          formData.append('originalSize', 'true')
          const imageRes = await POST('/upload-images/upload-one', formData)
          appconfigData.background = imageRes.success ? imageRes.image : ''
        }
        if (!background || background === '') {
          appconfigData.background = background
        }

        appconfigData.content = {
          qtdProductsPagination,
          useLogoMenu,
          colorLogo,
          useLogoTotvs,
          noConfirmed,
          noShadow,
          orderCategory,
          flagDiscount,
          noUseViewMode,
          pdv,
          showButtonClassification,
          showButtonCatalog,
          showClassificationName,
          showCatalogName,
          showProductInventory,
          showProductMark,
          showFlagDiscount,
          showProductSku,
          webappcolor: {
            backgroundbuttonhome,
            backgroundcart,
            backgroundfooter,
            backgroundheader,
            backgroundmenu,
            backgroundstatus,
            backgroundstatusactive,
            backgroundtitlebar,
            backgroundwebapp,
            fontbutton,
            fontbuttonhome,
            fontcart,
            fontcategory,
            fontheader,
            fontinfocart,
            fontmenu,
            fontstatus,
            fonttitlebar,
            highlightfooter,
            iconsfooter,
            iconsheader,
            icontitlebar,
            webappbutton,
            flagDiscountColor,
          },
          useCategoryList,
        }
        const appconfigRes = await PUT(`/appconfig/${id}`, appconfigData)
        setLoading(false)
        if (appconfigRes.success === true) {
          setCanAlert(false)
          Swal.fire({
            icon: 'success',
            title: 'Configuração alterada',
            text: 'Edição realizada com sucesso!',
          }).then(() => navigate('/webapp'))
        } else {
          setCanAlert(true)
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao alterar configuração!',
          })
        }
      }
    } catch (e) {
      setCanAlert(true)
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e && typeof e === 'string' ? e : 'Erro ao alterar configuração!',
      })
    }
  }

  const handleUnload = (e: BeforeUnloadEvent) => {
    e.preventDefault()
    e.returnValue = true
    localStorage.removeItem('webapp-personalize-saved')
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleUnload)
    return () => window.removeEventListener('beforeunload', handleUnload)
  }, [handleUnload])

  useEffect(() => {
    const configSaved = localStorage.getItem('webapp-personalize-saved')
    if (configSaved && JSON.parse(configSaved)) loadLocal()
    else getAppconfig()
    if (loginInfo.plugintype === 'aggregator') {
      getImageSlider()
    }
  }, [])

  useEffect(() => {
    return () => {
      if (canAlert && !window.location.pathname.includes(`/webapp/editar/${id}`)) {
        Swal.fire({
          title: 'Sair da página?',
          text: 'Há alterações não salvas que serão perdidas se você sair da página.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sair',
          cancelButtonText: 'Continuar editando',
        }).then((result) => {
          if (!result.isConfirmed) {
            navigate(`/webapp/editar/${id}`)
          } else {
            localStorage.removeItem('webapp-personalize-saved')
          }
        })
      } else if (!canAlert) localStorage.removeItem('webapp-personalize-saved')
    }
  }, [window.location.pathname, canAlert])

  const loadLocal = () => {
    const webappSaved = localStorage.getItem('webapp-personalize-saved')
    if (webappSaved && JSON.parse(webappSaved)) {
      setLoading(true)
      const jsonWebapp = JSON.parse(webappSaved)
      setName(jsonWebapp.name)
      setLocationId(jsonWebapp.locationId)
      setInfo(jsonWebapp.info)
      if (typeof jsonWebapp.background === 'string') setBackground(jsonWebapp.background)
      if (typeof jsonWebapp.banner === 'string') setBanner(jsonWebapp.banner)
      if (typeof jsonWebapp.img === 'string') setImg(jsonWebapp.img)
      if (typeof jsonWebapp.icon === 'string') setIcon(jsonWebapp.icon)
      if (typeof jsonWebapp.firstStateBackground === 'string')
        setFirstStateBackground(jsonWebapp.firstStateBackground)
      if (typeof jsonWebapp.firstStateBanner === 'string')
        setFirstStateBanner(jsonWebapp.firstStateBanner)
      if (typeof jsonWebapp.firstStateImg === 'string') setFirstStateImg(jsonWebapp.firstStateImg)
      if (typeof jsonWebapp.firstStateIcon === 'string')
        setFirstStateIcon(jsonWebapp.firstStateIcon)
      setQtdProductsPagination(jsonWebapp.qtdProductsPagination)
      setUseLogoMenu(jsonWebapp.useLogoMenu)
      setColorLogo(jsonWebapp.colorLogo)
      setUseLogoTotvs(jsonWebapp.useLogoTotvs)
      setBackgroundbuttonhome(jsonWebapp.backgroundbuttonhome)
      setBackgroundcart(jsonWebapp.backgroundcart)
      setBackgroundfooter(jsonWebapp.backgroundfooter)
      setBackgroundheader(jsonWebapp.backgroundheader)
      setBackgroundmenu(jsonWebapp.backgroundmenu)
      setBackgroundstatus(jsonWebapp.backgroundstatus)
      setBackgroundstatusactive(jsonWebapp.backgroundstatusactive)
      setBackgroundtitlebar(jsonWebapp.backgroundtitlebar)
      setBackgroundwebapp(jsonWebapp.backgroundwebapp)
      setFontbutton(jsonWebapp.fontbutton)
      setFontbuttonhome(jsonWebapp.fontbuttonhome)
      setFontcart(jsonWebapp.fontcart)
      setFontcategory(jsonWebapp.fontcategory)
      setFontheader(jsonWebapp.fontheader)
      setFontinfocart(jsonWebapp.fontinfocart)
      setFontmenu(jsonWebapp.fontmenu)
      setFontstatus(jsonWebapp.fontstatus)
      setFonttitlebar(jsonWebapp.fonttitlebar)
      setHighlightfooter(jsonWebapp.highlightfooter)
      setIconsfooter(jsonWebapp.iconsfooter)
      setIconsheader(jsonWebapp.iconsheader)
      setIcontitlebar(jsonWebapp.icontitlebar)
      setWebappbutton(jsonWebapp.webappbutton)
      setFlagDiscountColor(jsonWebapp.flagDiscountColor)
      setPdv(jsonWebapp.pdv)
      setUseCategoryList(jsonWebapp.useCategoryList)
      setNoShadow(jsonWebapp.noShadow)
      setOrderCategory(jsonWebapp.orderCategory)
      setFlagDiscount(jsonWebapp.flagDiscount)
      setShowProductInventory(jsonWebapp.showProductInventory)
      setShowProductSku(jsonWebapp.showProductSku)
      setShowProductMark(jsonWebapp.showProductMark)
      setShowButtonClassification(jsonWebapp.showButtonClassification)
      setShowButtonCatalog(jsonWebapp.showButtonCatalog)
      setShowClassificationName(jsonWebapp.showClassificationName)
      setShowCatalogName(jsonWebapp.showCatalogName)
      setShowFlagDiscount(jsonWebapp.showFlagDiscount)

      localStorage.removeItem('webapp-personalize-saved')
      setTimeout(() => {
        setLoading(false)
      }, 200)
    }
  }

  const saveLocal = () => {
    localStorage.setItem(
      'webapp-personalize-saved',
      JSON.stringify({
        name,
        locationId,
        info,
        background,
        banner,
        img,
        icon,
        firstStateBackground,
        firstStateBanner,
        firstStateImg,
        firstStateIcon,
        qtdProductsPagination,
        useLogoMenu,
        colorLogo,
        useLogoTotvs,
        backgroundbuttonhome,
        backgroundcart,
        backgroundfooter,
        backgroundheader,
        backgroundmenu,
        backgroundstatus,
        backgroundstatusactive,
        backgroundtitlebar,
        backgroundwebapp,
        fontbutton,
        fontbuttonhome,
        fontcart,
        fontcategory,
        fontheader,
        fontinfocart,
        fontmenu,
        fontstatus,
        fonttitlebar,
        highlightfooter,
        iconsfooter,
        iconsheader,
        icontitlebar,
        webappbutton,
        flagDiscountColor,
        pdv,
        useCategoryList,
        noShadow,
        orderCategory,
        flagDiscount,
        showProductInventory,
        showProductMark,
        showButtonClassification,
        showButtonCatalog,
        showClassificationName,
        showCatalogName,
        showFlagDiscount,
      })
    )
  }

  useEffect(() => {
    saveLocal()
  }, [
    name,
    locationId,
    info,
    background,
    banner,
    img,
    icon,
    firstStateBackground,
    firstStateBanner,
    firstStateImg,
    firstStateIcon,
    qtdProductsPagination,
    useLogoMenu,
    colorLogo,
    useLogoTotvs,
    backgroundbuttonhome,
    backgroundcart,
    backgroundfooter,
    backgroundheader,
    backgroundmenu,
    backgroundstatus,
    backgroundstatusactive,
    backgroundtitlebar,
    backgroundwebapp,
    fontbutton,
    fontbuttonhome,
    fontcart,
    fontcategory,
    fontheader,
    fontinfocart,
    fontmenu,
    fontstatus,
    fonttitlebar,
    highlightfooter,
    iconsfooter,
    iconsheader,
    icontitlebar,
    webappbutton,
    flagDiscountColor,
    pdv,
    useCategoryList,
    noShadow,
    orderCategory,
    flagDiscount,
    showProductInventory,
    showProductMark,
    showButtonClassification,
    showButtonCatalog,
    showClassificationName,
    showCatalogName,
    showFlagDiscount,

  ])

  async function addImagesSlideInitial() {
    closeWrapperModal()
    try {
      setLoading(true)

      await Promise.all(
        slidesImageAggregatorPreviewInitial.map(async (el) => {
          const formData = new FormData()
          formData.append('file', el.image)
          formData.append('nameImage', `slider/slider-${uuid()}.jpg`)
          formData.append('originalSize', 'true')

          const imageRes = await POST('/upload-images/upload-one', formData)

          if (imageRes && imageRes.success) {
            const urlImage = imageRes.image.split('https://s3.amazonaws.com/img.ninegrid.com/')[1]
            const schema = {
              pluginspaceId: 0,
              order: el.order ? el.order : 1,
              path: 'https://s3.amazonaws.com/img.ninegrid.com/',
              imgSuffix: urlImage,
              typeImg: 'image',
            }

            const response = await POST('pluginspaceimages', schema)

            console.log(response)
          }
        })
      )

      setLoading(false)

      Swal.fire({
        icon: 'success',
        titleText: 'Sucesso',
        text: 'Cadastro das imagens no slider concluido',
      }).then(() => {
        setSlidesImageAggregatorPreviewInitial([])
        getImageSlider()
      })
    } catch (error) {
      setLoading(false)
      console.log(error)

      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Ocorreu um erro ao salvar as imagens',
      })
    }
  }
  async function addImagesSlideHomePage() {
    closeWrapperModal()
    try {
      setLoading(true)

      await Promise.all(
        slidesImageAggregatorPreviewHomePage.map(async (el) => {
          const formData = new FormData()
          formData.append('file', el.image)
          formData.append('nameImage', `slider/slider-${uuid()}.jpg`)
          formData.append('originalSize', 'true')

          const imageRes = await POST('/upload-images/upload-one', formData)

          if (imageRes && imageRes.success) {
            const urlImage = imageRes.image.split('https://s3.amazonaws.com/img.ninegrid.com/')[1]
            const schema = {
              pluginspaceId: 0,
              order: el.order ? el.order : 1,
              path: 'https://s3.amazonaws.com/img.ninegrid.com/',
              imgSuffix: urlImage,
              typeImg: 'mainpicture',
            }

            const response = await POST('pluginspaceimages', schema)
          }
        })
      )

      setLoading(false)

      Swal.fire({
        icon: 'success',
        titleText: 'Sucesso',
        text: 'Cadastro das imagens no slider concluido',
      }).then(() => {
        setSlidesImageAggregatorPreviewInitial([])
        getImageSlider()
      })
    } catch (error) {
      setLoading(false)
      console.log(error)

      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Ocorreu um erro ao salvar as imagens',
      })
    }
  }

  function setImageToSliderPreviewInitial() {
    if (!slidesImageAggregator) {
      closeWrapperModal()
      Swal.fire({
        icon: 'warning',
        titleText: 'Atenção',
        text: 'Insira uma imagem valida para adicionar',
      }).then(() => showWrapperModal('Adicionar images ao Slider'))
    } else {
      setLoadingImages(true)

      const sliderAuxArray = slidesImageAggregatorPreviewInitial

      const newSlider: SlidersImage = {
        image: slidesImageAggregator,
        order: slidesImageAggregatorOrder,
      }

      sliderAuxArray.push(newSlider)

      setSlidesImageAggregator(null)
      setSlidesImageAggregatorOrder(0)

      const newArray = sliderAuxArray.sort((a, b) => a.order - b.order)

      setSlidesImageAggregatorPreviewInitial(newArray)

      setTimeout(() => {
        setLoadingImages(false)
      }, 50)
    }

    return
  }

  function setImageToSliderPreviewHomePage() {
    if (!slidesImageAggregator) {
      closeWrapperModal()
      Swal.fire({
        icon: 'warning',
        titleText: 'Atenção',
        text: 'Insira uma imagem valida para adicionar',
      }).then(() => showWrapperModal('Adicionar images ao Slider'))
    } else {
      setLoadingImages(true)

      const sliderAuxArray = slidesImageAggregatorPreviewHomePage

      const newSlider: SlidersImage = {
        image: slidesImageAggregator,
        order: slidesImageAggregatorOrder,
      }

      sliderAuxArray.push(newSlider)

      setSlidesImageAggregator(null)
      setSlidesImageAggregatorOrder(0)

      const newArray = sliderAuxArray.sort((a, b) => a.order - b.order)

      setSlidesImageAggregatorPreviewHomePage(newArray)

      setTimeout(() => {
        setLoadingImages(false)
      }, 50)
    }

    return
  }

  async function getImageSlider() {
    try {
      setLoading(true)

      const images = await GET('pluginspaceimages')

      if (images.data) {
        setImageSlidesAggregatorInitial(
          images.data.data.filter((data: any) => data.typeImg === 'image')
        )
        setImageSlidesAggregatorHomePage(
          images.data.data.filter((data: any) => data.typeImg === 'mainpicture')
        )
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const deleteImageSlider = async () => {
    try {
      setLoading(true)
      const gridRes = await DELETE(`/pluginspaceimages/${idImageSlider}`)
      if (gridRes.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Imagem deletada',
          text: 'Deleção realizada com sucesso!',
        }).then(async () => await getImageSlider())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao deletar a imagem!',
        }).then(async () => await getImageSlider())
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao deletar a imagem!',
      }).then(async () => await getImageSlider())
      console.log(e)
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12 py-5'>
          <div className='d-flex flex-row justify-content-between flex-wrap gap-5 '>
            <div className='card' style={{ flex: 1, minWidth: '30em' }}>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold fs-4 mb-1'>
                    {i18n.t(`webapp.webapp_data`)}
                  </span>

                  <BreadCrumbs />
                </h3>
              </div>
              <div className='px-10 py-5'>
                <div className='w-100 flex-wrap gap-5'>
                  <div className='d-flex justify-content-between align-items-center'>
                    <div className='w-100'>
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder={i18n.t(`webapp.name`)}
                        label={i18n.t(`webapp.name`)}
                        value={name}
                        change={(value: string) => {
                          setCanAlert(true)
                          setName(value)
                        }}
                      />
                    </div>
                  </div>
                  {loginInfo.plugintype !== 'aggregator' && (
                    <div className='d-flex justify-content-between align-items-end flex-wrap gap-5'>
                      <div className='w-100'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}

                          label={i18n.t(`webapp.product_pagination`)}
                          value={qtdProductsPagination}
                          change={(value: string) => {
                            setCanAlert(true)
                            setQtdProductsPagination(parseInt(value))
                          }}
                          options={selectProductsPagination}
                        />
                      </div>
                      <div className='w-100'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          placeholder={i18n.t(`webapp.logo_ninegrid`)}
                          label={i18n.t(`webapp.logo_ninegrid`)}
                          value={colorLogo}
                          change={(value: string) => {
                            setCanAlert(true)
                            setColorLogo(value)
                          }}
                          options={[
                            { select: i18n.t(`webapp.dark`), value: 'black' },
                            { select: i18n.t(`webapp.light`), value: 'white' },
                          ]}
                        />
                      </div>
                    </div>
                  )}
                  {loginInfo.plugintype !== 'aggregator' && (
                    <>
                      <div className='d-flex justify-content-between align-items-start mt-2 flex-wrap gap-5'>
                        {/*
                    <div className='w-100 '>
                      <Input
                        inputAttr={{
                          type: 'checkbox',
                        }}
                        label={i18n.t(`webapp.logo_totvs`)}
                        checkSwift={false}
                        checked={useLogoTotvs}
                        value={useLogoTotvs}
                        change={(value: boolean) => setUseLogoTotvs(value)}
                      />
                    </div>
                    */}
                        <div className='w-100 '>
                          <Input
                            inputAttr={{
                              type: 'checkbox',
                            }}
                            label={i18n.t(`webapp.use_icon_menu`)}
                            checkSwift={false}
                            checked={useLogoMenu}
                            value={useLogoMenu}
                            change={(value: boolean) => {
                              setCanAlert(true)
                              setUseLogoMenu(value)
                            }}
                          />
                        </div>
                      </div>
                      <div className='d-flex justify-content-between align-items-start mt-2 flex-wrap gap-2'>
                        <div className='w-100 '>
                          <Input
                            inputAttr={{
                              type: 'checkbox',
                            }}
                            label={i18n.t(`webapp.use_category_list`)}
                            checkSwift={false}
                            checked={useCategoryList}
                            value={useCategoryList}
                            change={(value: boolean) => setUseCategoryList(value)}
                          />
                        </div>
                        <div className='w-100 '>
                          <Input
                            inputAttr={{
                              type: 'checkbox',
                            }}
                            label={i18n.t(`webapp.remove_show_mode`)}
                            checkSwift={false}
                            checked={noUseViewMode}
                            value={noUseViewMode}
                            change={(value: boolean) => setNoUseViewMode(value)}
                          />
                        </div>
                        <div className='w-100 '>
                          <Input
                            inputAttr={{
                              type: 'checkbox',
                            }}
                            label={i18n.t(`webapp.no_shadow`)}
                            checkSwift={false}
                            checked={noShadow}
                            value={noShadow}
                            change={(value: boolean) => setNoShadow(value)}
                          />
                        </div>
                        {/* <div className='w-100 '>
                          <Input
                            inputAttr={{
                              type: 'checkbox',
                            }}
                            label={i18n.t(`webapp.confirmed_comanda`)} Esta tarefa será finalizada em breve
                            checkSwift={false}
                            checked={noConfirmed}
                            value={noConfirmed}
                            change={(value: boolean) => setConfirmed(value)}
                          />
                        </div> */}

                        {isWholesale && (
                          <>
                            <div className='w-100 '>
                              <Input
                                inputAttr={{
                                  type: 'checkbox',
                                }}
                                label={i18n.t(`webapp.show_classification_button`)}
                                checkSwift={false}
                                checked={showButtonClassification}
                                value={showButtonClassification}
                                change={(value: boolean) => setShowButtonClassification(value)}
                              />
                            </div>
                            <div className='w-100 '>
                              <Input
                                inputAttr={{
                                  type: 'checkbox',
                                }}
                                label={i18n.t(`webapp.show_catalog_button`)}
                                checkSwift={false}
                                checked={showButtonCatalog}
                                value={showButtonCatalog}
                                change={(value: boolean) => setShowButtonCatalog(value)}
                              />
                            </div>
                            <div className='w-100 '>
                              <Input
                                inputAttr={{
                                  type: 'checkbox',
                                }}
                                label={i18n.t(`webapp.show_classification_name`)}
                                checkSwift={false}
                                checked={showClassificationName}
                                value={showClassificationName}
                                change={(value: boolean) => setShowClassificationName(value)}
                              />
                            </div>
                            <div className='w-100 '>
                              <Input
                                inputAttr={{
                                  type: 'checkbox',
                                }}
                                label={i18n.t(`webapp.show_catalog_name`)}
                                checkSwift={false}
                                checked={showCatalogName}
                                value={showCatalogName}
                                change={(value: boolean) => setShowCatalogName(value)}
                              />
                            </div>
                            <div className='w-100 '>
                              <Input
                                inputAttr={{
                                  type: 'checkbox',
                                }}
                                label={i18n.t(`webapp.show_mark_name`)}

                                checkSwift={false}
                                checked={showProductMark}
                                value={showProductMark}
                                change={(value: boolean) => setShowProductMark(value)}
                              />
                            </div>
                            <div className='w-100 '>
                              <Input
                                inputAttr={{
                                  type: 'checkbox',
                                }}
                                label={i18n.t(`webapp.show_stock_quantity`)}
                                checkSwift={false}
                                checked={showProductInventory}
                                value={showProductInventory}
                                change={(value: boolean) => setShowProductInventory(value)}
                              />
                            </div>
                            <div className='w-100 '>
                              <Input
                                inputAttr={{
                                  type: 'checkbox',
                                }}
                                label={i18n.t(`webapp.show_product_sku`)}
                                checkSwift={false}
                                checked={showProductSku}
                                value={showProductSku}
                                change={(value: boolean) => setShowProductSku(value)}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      <div className='d-flex justify-content-between align-items-start mt-2 flex-wrap gap-5'>
                        <div className='w-100 '>
                          <Input
                            inputAttr={{
                              type: 'select',
                            }}
                            placeholder={i18n.t(`webapp.is_order_number`)}
                            label={i18n.t(`webapp.is_order_number`)}
                            value={orderCategory}
                            change={(value: string) => setOrderCategory(value)}
                            options={[
                              { select: i18n.t(`webapp.order_number`), value: 'order' },
                              { select: i18n.t(`webapp.order_category`), value: 'category' },
                            ]}
                          />
                        </div>
                        <div className='w-100 '></div>
                      </div>
                      <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                        <div className='w-100'>
                          <div className='mt-6'>
                            <label className='form-label fw-normal'>
                              {i18n.t(`webapp.description`)}
                            </label>
                            <EditorQuill
                              value={info}
                              change={(value: string) => setInfo(value)}
                            />

                           {/*
                            <Editor
                              apiKey={process.env.REACT_APP_TINY_KEY}
                              onEditorChange={(value: string) => setInfo(value)}
                              value={info}
                              init={{
                                height: 500,
                                menubar: false,
                                plugins: [
                                  'advlist autolink lists link image charmap print preview anchor',
                                  'searchreplace visualblocks code fullscreen',
                                  'insertdatetime media table paste code help wordcount',
                                ],
                                toolbar:
                                  'undo redo | formatselect | ' +
                                  'bold italic forecolor backcolor | alignleft aligncenter ' +
                                  'alignright alignjustify | bullist numlist outdent indent | ' +
                                  'removeformat | help',
                                content_style:
                                  'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                              }}
                            />
                           */}
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className='d-flex justify-content-between align-items-center mt-6 flex-wrap gap-5'>
                    <div className='justify-content-center d-flex'>
                      <Input
                        inputAttr={{
                          type: 'image',
                        }}
                        label='Background Webapp'
                        value={background}
                        change={(value: BaseSyntheticEvent) => {
                          setCanAlert(true)
                          setBackground(value ? value.target.files[0] : null)
                        }}
                      />
                    </div>
                    <div className='justify-content-center d-flex'>
                      <Input
                        inputAttr={{
                          type: 'image',
                        }}
                        label='Logo Webapp'
                        value={img}
                        change={(value: BaseSyntheticEvent) => {
                          setCanAlert(true)
                          setImg(value ? value.target.files[0] : null)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-center mt-6 flex-wrap gap-5'>
                    <div className='justify-content-center d-flex'>
                      <Input
                        inputAttr={{
                          type: 'image',
                        }}
                        label={`${i18n.t(`webapp.icon`)} Webapp`}
                        value={icon}
                        change={(value: BaseSyntheticEvent) => {
                          setCanAlert(true)
                          setIcon(value ? value.target.files[0] : null)
                        }}
                      />
                    </div>
                    <div className='justify-content-center d-flex'>
                      {loginInfo.plugintype === 'aggregator' && (
                        <Input
                          inputAttr={{
                            type: 'image',
                          }}
                          label='Banner Webapp'
                          value={banner}
                          change={(value: BaseSyntheticEvent) => {
                            setCanAlert(true)
                            setBanner(value ? value.target.files[0] : null)
                          }}
                        />
                      )}
                      {(loginInfo.plugintype === 'fashion' || loginInfo.plugintype === 'food') && (
                        <Input
                          inputAttr={{
                            type: 'image',
                          }}
                          label={`${i18n.t(`webapp.icon`)} Aba (16x16)`}
                          value={banner}
                          change={(value: BaseSyntheticEvent) => {
                            setCanAlert(true)
                            setBanner(value ? value.target.files[0] : null)
                          }}
                        />
                      )}
                    </div>
                  </div>
                  {loginInfo.plugintype !== 'food' && (
                    <>
                      <div className={styles.configTags}>
                        <h3>{i18n.t(`webapp.config_tags`)}</h3>
                        <p>{i18n.t(`webapp.promotional_tags`)}</p>
                      </div>
                      <div className='w-100 '>
                        <Input
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          label={i18n.t(`webapp.show_promotional_tags`)}
                          checkSwift={false}
                          checked={showFlagDiscount}
                          value={showFlagDiscount}
                          change={(value: boolean) => setShowFlagDiscount(value)}
                        />
                      </div>
                      {showFlagDiscount && (
                        <div className='d-flex justify-content-between align-items-center mt-2 flex-wrap gap-5'>
                          <div className='justify-content-center d-flex'>
                            <label className='form-check'>
                              <input
                                type='checkbox'
                                className={`form-check-input ${styles.checkboxCupom}`}
                                checked={flagDiscount === 'trigonal'}
                                onChange={() => setFlagDiscount('trigonal')}
                              />
                              <span className={`form-check-label fw-normal text-gray-800 ms-1`}>
                                <div className={styles.inputItemCupom}>
                                  <p>
                                    <b>-20% </b>
                                    <br />
                                    off
                                  </p>
                                  <svg
                                    width='41'
                                    height='31'
                                    viewBox='0 0 41 31'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M1.89117 18.2568C1.89278 18.2536 1.89715 18.2529 1.89971 18.2555L11.7947 28.2901C12.9182 29.4295 14.4515 30.0796 16.0377 30.0796H34.2174C37.5285 30.0796 40.2117 27.3652 40.2051 24.0074V6.07892C40.2051 2.7144 37.5219 0 34.2108 0H16.0377C14.4515 0 12.9248 0.636711 11.7947 1.78279L1.90108 11.8227C0.144863 13.597 0.143095 16.4817 1.8826 18.2582C1.88515 18.2608 1.88955 18.2601 1.89117 18.2568V18.2568ZM6.2696 12.3723C7.60461 11.0185 9.77235 11.0185 11.114 12.3723C12.449 13.7262 12.449 15.9312 11.114 17.285C9.77896 18.6389 7.61122 18.6389 6.2696 17.285C4.93459 15.9312 4.93459 13.7262 6.2696 12.3723Z'
                                      fill='black'
                                    />
                                  </svg>
                                </div>
                              </span>
                            </label>
                          </div>

                          <div className='justify-content-center d-flex'>
                            <label className='form-check'>
                              <input
                                type='checkbox'
                                className={`form-check-input ${styles.checkboxCupom}`}
                                checked={flagDiscount === 'rectangular'}
                                onChange={() => setFlagDiscount('rectangular')}
                              />
                              <span className={`form-check-label fw-normal text-gray-800 ms-1`}>
                                <div className={styles.inputItemCupom}>
                                  <p style={{ marginBottom: '0.7em', marginRight: '0.5em' }}>
                                    <b>-20% </b>
                                    <br />
                                    off
                                  </p>
                                  <svg
                                    width='63'
                                    height='41'
                                    viewBox='0 0 63 41'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <g filter='url(#filter0_d_6746_10256)'>
                                      <path
                                        d='M54.4579 16.4307C54.4579 13.9232 56.4925 11.8886 58.989 11.8886V4.4871C56.5035 4.4871 54.4909 2.4855 54.4579 0H8.46511C8.43211 2.46351 6.45251 4.44311 4 4.4871V11.9986C6.47451 12.0316 8.47611 14.0442 8.47611 16.5297C8.47611 19.0152 6.47451 21.0278 4 21.0608V28.5723C6.44151 28.6053 8.41012 30.5629 8.46511 33.0044H54.4689C54.4689 33.0044 54.4689 32.9494 54.4689 32.9164C54.4689 30.4089 56.5035 28.3743 59 28.3743V20.9728C56.4925 20.9728 54.4689 18.9382 54.4689 16.4307H54.4579Z'
                                        fill='#000'
                                      />
                                    </g>
                                    <defs>
                                      <filter
                                        id='filter0_d_6746_10256'
                                        x='0'
                                        y='0'
                                        width='63'
                                        height='41.0044'
                                        filterUnits='userSpaceOnUse'
                                        color-interpolation-filters='sRGB'
                                      >
                                        <feFlood flood-opacity='0' result='BackgroundImageFix' />
                                        <feColorMatrix
                                          in='SourceAlpha'
                                          type='matrix'
                                          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                                          result='hardAlpha'
                                        />
                                        <feOffset dy='4' />
                                        <feGaussianBlur stdDeviation='2' />
                                        <feComposite in2='hardAlpha' operator='out' />
                                        <feColorMatrix
                                          type='matrix'
                                          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
                                        />
                                        <feBlend
                                          mode='normal'
                                          in2='BackgroundImageFix'
                                          result='effect1_dropShadow_6746_10256'
                                        />
                                        <feBlend
                                          mode='normal'
                                          in='SourceGraphic'
                                          in2='effect1_dropShadow_6746_10256'
                                          result='shape'
                                        />
                                      </filter>
                                    </defs>
                                  </svg>
                                </div>
                              </span>
                            </label>
                          </div>

                          <div className='justify-content-center d-flex'>
                            <label className='form-check'>
                              <input
                                type='checkbox'
                                className={`form-check-input ${styles.checkboxCupom}`}
                                checked={flagDiscount === 'round'}
                                onChange={() => setFlagDiscount('round')}
                              />
                              <span className={`form-check-label fw-normal text-gray-800 ms-1`}>
                                <div className={styles.inputItemCupom}>
                                  <p style={{ marginLeft: 0 }}>
                                    <b>-20% </b>
                                    <br />
                                    off
                                  </p>
                                  <svg
                                    width='37'
                                    height='40'
                                    viewBox='0 0 37 40'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M35.9708 17.9045C35.9708 19.338 35.8727 20.3158 35.5544 21.652C35.5544 21.652 35.5544 21.652 29.7251 27.4813C21.8138 35.4162 21.8138 35.4162 21.8138 35.4162C20.6052 35.6736 19.3516 35.809 18.0663 35.809C8.17793 35.809 0.161804 27.7929 0.161804 17.9045C0.161804 8.01612 8.17793 0 18.0663 0C27.9547 0 35.9708 8.01612 35.9708 17.9045Z'
                                      fill='black'
                                    />
                                    <g filter='url(#filter0_d_7492_192)'>
                                      <path
                                        d='M21.8135 35.3581C21.8135 27.7884 27.95 21.6519 35.5197 21.6519L21.8135 35.3581Z'
                                        fill='#3C3C3C'
                                      />
                                    </g>
                                    <defs>
                                      <filter
                                        id='filter0_d_7492_192'
                                        x='14.8135'
                                        y='17.6519'
                                        width='21.7062'
                                        height='21.7062'
                                        filterUnits='userSpaceOnUse'
                                        color-interpolation-filters='sRGB'
                                      >
                                        <feFlood flood-opacity='0' result='BackgroundImageFix' />
                                        <feColorMatrix
                                          in='SourceAlpha'
                                          type='matrix'
                                          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                                          result='hardAlpha'
                                        />
                                        <feOffset dx='-3' />
                                        <feGaussianBlur stdDeviation='2' />
                                        <feComposite in2='hardAlpha' operator='out' />
                                        <feColorMatrix
                                          type='matrix'
                                          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
                                        />
                                        <feBlend
                                          mode='normal'
                                          in2='BackgroundImageFix'
                                          result='effect1_dropShadow_7492_192'
                                        />
                                        <feBlend
                                          mode='normal'
                                          in='SourceGraphic'
                                          in2='effect1_dropShadow_7492_192'
                                          result='shape'
                                        />
                                      </filter>
                                    </defs>
                                  </svg>
                                </div>
                              </span>
                            </label>
                          </div>

                          <div className='justify-content-center d-flex'>
                            <label className='form-check'>
                              <input
                                type='checkbox'
                                className={`form-check-input ${styles.checkboxCupom}`}
                                checked={flagDiscount === 'square'}
                                onChange={() => setFlagDiscount('square')}
                              />
                              <span className={`form-check-label fw-normal text-gray-800 ms-1`}>
                                <div className={styles.inputItemCupom}>
                                  <p style={{ marginBottom: '0.8em', marginRight: '2em' }}>
                                    <b>-20% </b>
                                    <br />
                                    off
                                  </p>
                                  <svg
                                    width='58'
                                    height='47'
                                    viewBox='0 0 58 47'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <g filter='url(#filter0_d_6746_10276)'>
                                      <path
                                        d='M7.03444 38.9892C21.5601 38.9513 38.6614 38.9608 39.3496 38.9608C39.3496 37.3518 39.3392 35.8278 39.3496 34.3134C39.3705 32.8273 39.047 32.0134 40.34 32.0228C41.6331 32.0228 41.2992 32.8463 41.32 34.3323C41.3304 35.8184 41.32 37.3044 41.32 38.9703C43.124 38.9703 48.2961 38.9135 50.9343 38.9987C50.9447 38.9987 50.9551 38.9987 50.976 38.9987C52.6444 39.046 54 37.8061 54 36.3579L54 26.3153C53.4369 25.4161 52.5506 25.1037 51.4035 25.009C48.2127 24.744 45.9186 22.4913 45.9603 19.7843C46.002 17.1151 48.2752 14.9475 51.4035 14.692C52.5506 14.5973 53.4473 14.285 54 13.3858L54 3.38102C54 1.92337 52.6653 0.683414 50.976 0.702343C50.9656 0.702343 50.9551 0.702343 50.9343 0.702343C46.6694 0.7686 45.929 0.730766 41.4452 0.730765C41.4452 2.31146 41.4452 3.83538 41.4452 5.35928C41.4347 6.87371 41.7999 7.66875 40.5173 7.67821C39.2347 7.68768 39.5478 6.86422 39.5373 5.38764C39.5269 3.9016 39.5373 2.40611 39.5373 0.730765C38.9221 0.730765 21.6331 0.740201 7.0553 0.702339C5.36603 0.702339 4 1.88553 4 3.34318L4 36.3484C4 37.8061 5.36602 38.9892 7.0553 38.9892L7.03444 38.9892ZM41.393 26.9778C41.3409 27.9622 41.6018 28.5017 40.5486 28.5207C39.412 28.5396 39.6937 27.9528 39.5582 26.94C39.4748 26.2869 39.5373 25.6243 39.5373 24.9712C39.5373 24.356 39.4435 23.7313 39.5582 23.135C39.7459 22.16 39.412 21.5353 40.5799 21.5921C41.6539 21.6394 41.3409 22.2073 41.393 23.1728C41.466 24.4411 41.4556 25.719 41.393 26.9873L41.393 26.9778ZM39.5895 12.6286C39.6833 11.6915 39.4641 11.133 40.5277 11.1614C41.5809 11.1898 41.2887 11.7104 41.393 12.6948C41.466 13.3479 41.4034 14.0105 41.4034 14.6636C41.4034 14.6636 41.4034 14.6636 41.4139 14.6636C41.4139 15.2788 41.466 15.894 41.4034 16.4998C41.2887 17.5315 41.6018 18.1089 40.4547 18.0994C39.3703 18.0994 39.6625 17.4937 39.579 16.5661C39.4643 15.2599 39.4539 13.9348 39.5895 12.6286Z'
                                        fill='#000'
                                      />
                                    </g>
                                    <defs>
                                      <filter
                                        id='filter0_d_6746_10276'
                                        x='0'
                                        y='0.702148'
                                        width='58'
                                        height='46.2979'
                                        filterUnits='userSpaceOnUse'
                                        color-interpolation-filters='sRGB'
                                      >
                                        <feFlood flood-opacity='0' result='BackgroundImageFix' />
                                        <feColorMatrix
                                          in='SourceAlpha'
                                          type='matrix'
                                          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                                          result='hardAlpha'
                                        />
                                        <feOffset dy='4' />
                                        <feGaussianBlur stdDeviation='2' />
                                        <feComposite in2='hardAlpha' operator='out' />
                                        <feColorMatrix
                                          type='matrix'
                                          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
                                        />
                                        <feBlend
                                          mode='normal'
                                          in2='BackgroundImageFix'
                                          result='effect1_dropShadow_6746_10276'
                                        />
                                        <feBlend
                                          mode='normal'
                                          in='SourceGraphic'
                                          in2='effect1_dropShadow_6746_10276'
                                          result='shape'
                                        />
                                      </filter>
                                    </defs>
                                  </svg>
                                </div>
                              </span>
                            </label>
                          </div>
                        </div>
                      )

                      }
                    </>
                  )}
                </div>
              </div>
              <div className='d-flex justify-content-between px-11 py-5'>
                <Button
                  text={i18n.t(`buttons.back`)}
                  color='info'
                  size='small'
                  horizontalPadding={5}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    navigate('/webapp')
                  }}
                  btnClass='fw-bolder me-3'
                />

                <Button
                  text={i18n.t(`buttons.save`)}
                  color='primary'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    setCanAlert(false)
                    saveAppconfig()
                  }}
                  btnClass='fw-bolder'
                />
              </div>
            </div>

            <div className='card' style={{ flex: 1, minWidth: '30em' }}>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold fs-4 mb-1'>
                    {i18n.t(`webapp.color_setting`)}
                  </span>
                </h3>
              </div>
              {loginInfo.plugintype === 'aggregator' ? (
                <div className='px-10 py-5'>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.background_webapp`)}
                        value={backgroundwebapp}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundwebapp(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.background_header`)}
                        value={backgroundheader}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundheader(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_header`)}
                        value={fontheader}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontheader(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.icon_header`)}
                        value={iconsheader}
                        change={(value: string) => {
                          setCanAlert(true)
                          setIconsheader(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.background_footer`)}
                        value={backgroundfooter}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundfooter(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.icon_footer`)}
                        value={iconsfooter}
                        change={(value: string) => {
                          setCanAlert(true)
                          setIconsfooter(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.home_button`)}
                        value={backgroundbuttonhome}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundbuttonhome(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_home_button`)}
                        value={fontbuttonhome}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontbuttonhome(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label='Botões do Webappp'
                        value={webappbutton}
                        change={(value: string) => {
                          setCanAlert(true)
                          setWebappbutton(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_button`)}
                        value={fontbutton}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontbutton(value)
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className='px-10 py-5'>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.background_webapp`)}
                        value={backgroundwebapp}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundwebapp(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.background_header`)}
                        value={backgroundheader}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundheader(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_header`)}
                        value={fontheader}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontheader(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.icon_header`)}
                        value={iconsheader}
                        change={(value: string) => {
                          setCanAlert(true)
                          setIconsheader(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.background_footer`)}
                        value={backgroundfooter}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundfooter(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.icon_footer`)}
                        value={iconsfooter}
                        change={(value: string) => {
                          setCanAlert(true)
                          setIconsfooter(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.highlight_footer`)}
                        value={highlightfooter}
                        change={(value: string) => {
                          setCanAlert(true)
                          setHighlightfooter(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.notification_cart`)}
                        value={backgroundcart}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundcart(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.notification_text`)}
                        value={fontcart}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontcart(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.home_button`)}
                        value={backgroundbuttonhome}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundbuttonhome(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_home_button`)}
                        value={fontbuttonhome}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontbuttonhome(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.title_bar`)}
                        value={backgroundtitlebar}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundtitlebar(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_title_bar`)}
                        value={fonttitlebar}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFonttitlebar(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.icon_title_bar`)}
                        value={icontitlebar}
                        change={(value: string) => {
                          setCanAlert(true)
                          setIcontitlebar(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_category`)}
                        value={fontcategory}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontcategory(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label='Botões do Webappp'
                        value={webappbutton}
                        change={(value: string) => {
                          setCanAlert(true)
                          setWebappbutton(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_button`)}
                        value={fontbutton}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontbutton(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.background_menu`)}
                        value={backgroundmenu}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundmenu(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_menu`)}
                        value={fontmenu}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontmenu(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.order_status`)}
                        value={backgroundstatus}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundstatus(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.order_active_status`)}
                        value={backgroundstatusactive}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBackgroundstatusactive(value)
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.text_order_active_status`)}
                        value={fontstatus}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontstatus(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                    <div style={{ flex: 1 }}>
                      <Input
                        inputAttr={{
                          type: 'color',
                        }}
                        label={i18n.t(`webapp.info_cart`)}
                        value={fontinfocart}
                        change={(value: string) => setFontinfocart(value)}
                      />
                    </div>
                    {loginInfo.plugintype !== 'food' ? (
                      <div style={{ flex: 1 }}>
                        <Input
                          inputAttr={{
                            type: 'color',
                          }}
                          label={i18n.t(`webapp.color_flag_discount`)}
                          value={flagDiscountColor}
                          change={(value: string) => setFlagDiscountColor(value)}
                        />
                      </div>
                    ) : (
                      <div style={{ flex: 1 }}></div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          {loginInfo.plugintype === 'aggregator' && (
            <div className='w-100 d-flex gap-5'>
              <div className='card w-100'>
                <div className='card-header py-5'>
                  <h3 className='card-title align-items-between flex-row'>
                    <span className='card-label fw-bold fs-4 mb-1'>
                      {i18n.t(`webapp.slides_initial`)}
                    </span>
                  </h3>

                  <Button
                    text={i18n.t(`buttons.add`)}
                    color='primary'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      setAction('initial')
                      showWrapperModal(
                        `${i18n.t(`buttons.add`)} ${i18n.t(`webapp.slides_initial`)}`
                      )
                    }}
                    btnClass='fw-bolder'
                  />
                </div>
                <div className='card-body py-5'>
                  {ImageSlidesAggregatorInitial.length > 0 ? (
                    <div className='d-flex gap-5 flex-row overflow-auto'>
                      {ImageSlidesAggregatorInitial.map((img) => (
                        <div className='position-relative'>
                          <i
                            className='fa fa-times position-absolute text-danger top-0 me-5'
                            aria-hidden='true'
                            onClick={() => {
                              showDeleteModal(`${i18n.t(`general.delete`)} Imagem do Slider`)
                              setIdImageSlider(img.id)
                            }}
                            style={{
                              fontSize: '2rem',
                              left: '85%',
                            }}
                          />
                          <img
                            src={`${img.path}${img.imgSuffix}`}
                            style={{
                              height: '25rem',
                              width: 'auto',
                              maxWidth: '150px',
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className='card w-100'>
                <div className='card-header py-5'>
                  <h3 className='card-title align-items-between flex-row'>
                    <span className='card-label fw-bold fs-4 mb-1'>
                      {i18n.t(`webapp.slides_homePage`)}
                    </span>
                  </h3>

                  <Button
                    text={i18n.t(`buttons.add`)}
                    color='primary'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      setAction('homepage')
                      showWrapperModal(
                        `${i18n.t(`buttons.add`)} ${i18n.t(`webapp.slides_homePage`)}`
                      )
                    }}
                    btnClass='fw-bolder'
                  />
                </div>
                <div className='card-body py-5'>
                  {ImageSlidesAggregatorHomePage.length > 0 ? (
                    <div className='d-flex gap-5 flex-row overflow-auto'>
                      {ImageSlidesAggregatorHomePage.map((img) => (
                        <div className='position-relative'>
                          <i
                            className='fa fa-times position-absolute text-danger top-0 me-5'
                            aria-hidden='true'
                            onClick={() => {
                              showDeleteModal(`${i18n.t(`general.delete`)} Imagem do Slider`)
                              setIdImageSlider(img.id)
                            }}
                            style={{
                              fontSize: '2rem',
                              left: '85%',
                            }}
                          />
                          <img
                            src={`${img.path}${img.imgSuffix}`}
                            style={{
                              height: '25rem',
                              width: 'auto',
                              maxWidth: '150px',
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          )}

          <ModalWrapper
            confirmAction={() => {
              action === 'initial' ? addImagesSlideInitial() : addImagesSlideHomePage()
            }}
            maxWidth={true}
          >
            <>
              {action === 'initial' ? (
                <>
                  <div className='d-flex flex-column p-8 '>
                    <div className='d-flex flex-column justify-content-center mb-5'>
                      <Input
                        inputAttr={{
                          type: 'image',
                        }}
                        label={`${i18n.t(`webapp.slides`)} Webapp`}
                        value={slidesImageAggregator}
                        change={(value: BaseSyntheticEvent) =>
                          setSlidesImageAggregator(value ? value.target.files[0] : null)
                        }
                      />
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        label={`Ordem do ${i18n.t(`webapp.slides`)}`}
                        value={slidesImageAggregatorOrder}
                        change={(value: any) => setSlidesImageAggregatorOrder(parseInt(value))}
                      />
                    </div>

                    <div className='w-100 d-flex justify-content-end'>
                      <Button
                        text={`${i18n.t(`buttons.add`)}`}
                        color={'primary'}
                        click={() => {
                          setImageToSliderPreviewInitial()
                        }}
                      />
                    </div>
                  </div>

                  <div className='card-body'>
                    <div className='d-flex gap-5 flex-row overflow-auto'>
                      {loadingImages ? (
                        <>
                          <Loading />
                        </>
                      ) : (
                        <>
                          {slidesImageAggregatorPreviewInitial.map((img, index) => (
                            <div className='position-relative'>
                              <i
                                className='fa fa-times position-absolute top-0 me-5'
                                aria-hidden='true'
                                onClick={() => {
                                  setLoading(true)
                                  const newSlider = slidesImageAggregatorPreviewInitial
                                  newSlider.splice(index, 1)
                                  setSlidesImageAggregatorPreviewInitial(newSlider)

                                  setTimeout(() => {
                                    setLoading(false)
                                  }, 100)
                                }}
                                style={{
                                  fontSize: '2rem',
                                  left: '90%',
                                }}
                              />
                              <img
                                src={URL.createObjectURL(img.image)}
                                alt=''
                                style={{
                                  width: '250px',
                                  height: '250px',
                                }}
                              />
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className='d-flex flex-column p-8 '>
                    <div className='d-flex flex-column justify-content-center mb-5'>
                      <Input
                        inputAttr={{
                          type: 'image',
                        }}
                        label={`${i18n.t(`webapp.slides`)} Webapp`}
                        value={slidesImageAggregator}
                        change={(value: BaseSyntheticEvent) =>
                          setSlidesImageAggregator(value ? value.target.files[0] : null)
                        }
                      />
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        label={`Ordem do ${i18n.t(`webapp.slides`)}`}
                        value={slidesImageAggregatorOrder}
                        change={(value: any) => setSlidesImageAggregatorOrder(parseInt(value))}
                      />
                    </div>

                    <div className='w-100 d-flex justify-content-end'>
                      <Button
                        text={`${i18n.t(`buttons.add`)}`}
                        color={'primary'}
                        click={() => {
                          setImageToSliderPreviewHomePage()
                        }}
                      />
                    </div>
                  </div>

                  <div className='card-body'>
                    <div className='d-flex gap-5 flex-row overflow-auto'>
                      {loadingImages ? (
                        <>
                          <Loading />
                        </>
                      ) : (
                        <>
                          {slidesImageAggregatorPreviewHomePage.map((img, index) => (
                            <div className='position-relative'>
                              <i
                                className='fa fa-times position-absolute top-0 me-5'
                                aria-hidden='true'
                                onClick={() => {
                                  setLoading(true)
                                  const newSlider = slidesImageAggregatorPreviewHomePage
                                  newSlider.splice(index, 1)
                                  setSlidesImageAggregatorPreviewHomePage(newSlider)

                                  setTimeout(() => {
                                    setLoading(false)
                                  }, 100)
                                }}
                                style={{
                                  fontSize: '2rem',
                                  left: '90%',
                                }}
                              />
                              <img
                                src={URL.createObjectURL(img.image)}
                                alt=''
                                style={{
                                  width: '250px',
                                  height: '250px',
                                }}
                              />
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}
            </>
          </ModalWrapper>

          <ModalDelete confirmAction={() => deleteImageSlider()} />
        </div>
      )}
    </>
  )
}

const EditarWebapp: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: true },
          { title: 'Webapp', path: 'webapp', isActive: true },
          { title: i18n.t(`general.edit`), path: 'webapp/editar', isActive: true },
        ]}
      >
        {`${i18n.t(`general.edit`)} Webapp`}
      </PageTitle>
      <EditarWebappContent />
    </>
  )
}

export { EditarWebapp }
